import React from "react";
import "./SuccessStoriescard.css";

const SuccessStoriesCard = ({ title, description, date, image, text }) => {
  return (
    <div className="success-card">
      <img src={`https://kovaikongunadumatrimony.com/kkm_admin/public/${image}`} alt={title} className="success-card-image" />
      <div className="success-card-body">
        <h3>{title}</h3>
        <small>Posted on: {date}</small>
        <p>{description}</p>
        <h5>{text}</h5>
      </div>
    </div>
  );
};

export default SuccessStoriesCard;
